import React, { lazy, Suspense } from 'react';

import { getEnvConfig } from 'config/environment';

const ApplicationInsights = lazy(() => import('./ApplicationInsights'));
const OpenReplay = lazy(() => import('./OpenReplay'));
const ReactGA = lazy(() => import('./ReactGA'));

const openReplayProjectKey = (getEnvConfig().REACT_APP_OPENREPLAY_PROJECTKEY || '').trim();
const appInsightsInstrumentationKey = (getEnvConfig().REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY || '').trim();
const googleAnalyticsTrackingId = (getEnvConfig().REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || '').trim();

const AnalyticsProvider = ({ children }) => (
  <>
    <Suspense>
      {!!openReplayProjectKey && <OpenReplay projectKey={openReplayProjectKey} />}
      {!!appInsightsInstrumentationKey && <ApplicationInsights instrumentationKey={appInsightsInstrumentationKey} />}
      {!!googleAnalyticsTrackingId && <ReactGA trackingId={googleAnalyticsTrackingId} />}
    </Suspense>
    {children}
  </>
);

export default AnalyticsProvider;
